<template>
  <v-slide-group multiple show-arrows>
    <v-slide-item v-for="t in slideData" :key="t.id" class="mr-12">
      <v-hover v-slot:default="{ hover }">
        <v-card
          :elevation="hover ? 12 : 2"
          :class="[{ 'on-hover': hover }, 'mx-auto']"
          max-width="300"
        >
          <router-link :to="{ name: 'Details', query: { record: t.id } }" @click="this.$ga.event({
  eventAction: 'route-to-details-page',
  eventLabel: 'slidegroup'
})">
            <v-img
              contain
              :src="t.fields.IMAGE"
              :alt="t.fields.IMAGE"
              height="200px"
            ></v-img>

            <v-card-text style="position: relative;">
              <v-card-title>
                {{ t.fields.TITLE }}
              </v-card-title>

              <v-card-subtitle class="black--text">
                {{ t.fields.DESCRIPTION }}
              </v-card-subtitle>
              <v-btn
                aria-label="Add to Cart button"
                absolute
                right
                top
                @click.prevent="addToCart(t)"
                fab
                large
                color="amber darken-1"
              >
                <img
                  src="@/assets/icons/add_shopping_cart.svg"
                  alt="Add to Shopping Cart icon"
                />
              </v-btn>
            </v-card-text>
          </router-link>
          <v-card-actions>
            <v-col class="text-left">
              <v-rating
                aria-label="Rate out of 5 stars"
                readonly
                :value="parseFloat(t.fields.RATING)"
                background-color="grey darken-1"
                empty-icon="$ratingFull"
                half-increments
                small
                hover
              >
                <template v-slot:item="props">
                  <v-icon aria-label="star" color="yellow darken-3" size="20">{{
                    props.isFilled ? "mdi-star" : "mdi-star-outline"
                  }}</v-icon>
                </template>
              </v-rating>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-hover>
    </v-slide-item>
  </v-slide-group>
</template>

<script>
import algoliasearch from "algoliasearch";

export default {
  props: {
    slideData: Array,
    isLoading: Boolean,
  },
  data() {
    return {
      show: false,
      searchClient: algoliasearch(
        "U7CA3GDTX2",
        "a56c7927f04fc5fda073a4b1ae942ef6"
      ),
    };
  },
  methods: {
    addToCart(t) {
      this.$store.dispatch("addCartItem", t);

      window.aa("AddToCartFromSlideGroup", {
        userToken: "user-1928fh19fh38",
        index: "Airtable",
        eventName: "add_to_cart",
        objectIDs: ["objectID1"],
      });
    },
  },
};
</script>

<style scoped>
.v-card {
  transition: opacity 0.4s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.8;
}

.v-card__subtitle {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding-bottom: 0;
  padding-top: 1rem;
}
</style>
